import { LittleModalCreateEdit } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { ShippingZoneGroupModelType } from '@teinor/erp/types/company/config/shipping/shippingZoneGroup'


interface ModalCEConfigShippingZoneGroupProps extends ModalEditComponentProps { }

const ModalCEConfigShippingZoneGroup: React.FC<ModalCEConfigShippingZoneGroupProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const fields: FormRender<ShippingZoneGroupModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                }
            ]
        },
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit fields={parsedFields} url={'/api/app/config/shipping/shippingZone/updateShippingZoneGroup'} translations={{ title: t('editZone', 'Editar zona'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }

    return (<LittleModalCreateEdit fields={fields} url={'/api/app/config/shipping/shippingZone/createShippingZoneGroup'} translations={{
        title: t('createNewZone', 'Crear nueva zona'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

export default ModalCEConfigShippingZoneGroup